import React, { useState } from 'react';
import { Box, Typography, Grid, Stack, Pagination, IconButton, Tooltip } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DashboardLayoutSlots from './DashboardLayoutSlots';
import Listing from './Listing';  // Import the Listing component
import Filter from './Filter'; // Import the Filter component
import { AccessTime, PendingActions, CheckCircle, Cancel, HourglassEmpty, AllOut } from '@mui/icons-material'; // Example icons


const Dashboard = () => {
  const [page, setPage] = useState(1);
  const [openFilter, setOpenFilter] = useState(false); // State to control the modal visibility

  const WorkOrders = [
    { id: 1, orderNo: 'RM-24-0001', description: 'Flex to max', location: 'PLANT A', status: 'ACK', date: '24 JAN' },
    { id: 2, orderNo: 'RM-24-0002', description: 'Machine setup', location: 'PLANT B', status: 'WIP', date: '25 FEB' },
    { id: 3, orderNo: 'RM-24-0003', description: 'Packing materials', location: 'PLANT C', status: 'CMP', date: '26 MAR' },
    { id: 4, orderNo: 'RM-24-0004', description: 'Assembly', location: 'PLANT D', status: 'ACK', date: '27 APR' },
    { id: 5, orderNo: 'RM-24-0005', description: 'Inspection', location: 'PLANT E', status: 'CLS', date: '28 MAY' },
    { id: 6, orderNo: 'RM-24-0006', description: 'Shipping', location: 'PLANT F', status: 'WIP', date: '29 JUN' },
    { id: 7, orderNo: 'RM-24-0007', description: 'Installation', location: 'PLANT G', status: 'ACK', date: '30 JUL' },
    { id: 8, orderNo: 'RM-24-0008', description: 'Maintenance', location: 'PLANT H', status: 'CLS', date: '31 AUG' },
    { id: 9, orderNo: 'RM-24-0009', description: 'Test run', location: 'PLANT I', status: 'WIP', date: '1 SEP' },
    { id: 10, orderNo: 'RM-24-0010', description: 'Calibration', location: 'PLANT J', status: 'ACK', date: '2 OCT' },
  ];

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  // Open the filter modal
  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  // Close the filter modal
  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  return (
    <DashboardLayoutSlots>
        <Box sx={{ padding: 4 }}>
        {/* Dashboard Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 }}>
          {/* Dashboard Title on the Left */}
          <Typography variant="h4" component="h1">
            Dashboard
          </Typography>

          {/* Container for Date and Filter Icon on the Right */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="p" component="p" sx={{ marginRight: 2 }}>
              01 JUN - 04 AUG 2025
            </Typography>

            {/* Filter Icon on the Right */}
            <Tooltip title="Filter list">
              <IconButton onClick={handleOpenFilter}>
                <FilterListIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>


        {/* Stats Grid (Cards with Metrics) */}
        <Grid container spacing={3} justifyContent="space-between">
      {[
        { label: 'Open Request', icon: <AccessTime /> },
        { label: 'In Progress Request', icon: <PendingActions /> },
        { label: 'Acknowledge Request', icon: <CheckCircle /> },
        { label: 'Closed Request', icon: <Cancel /> },
        { label: 'Rejected Request', icon: <HourglassEmpty /> },
        { label: 'All Request', icon: <AllOut /> },
      ].map((item, idx) => (
        <Grid item xs={12} sm={6} md={4} key={idx}>
          <Box
            sx={{
              backgroundColor: 'black',
              padding: 2,
              textAlign: 'center',
              color: 'white',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'stretch', // Stretch both sections to fill height
            }}
          >
            {/* Icon Section */}
            <Box
              sx={{
                backgroundColor: 'purple', // Icon background
                color: 'white',
                width: '25%', // 1/4th of the box
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {item.icon}
            </Box>

            {/* Text Section (Right side) */}
            <Box
              sx={{
                width: '75%', // 3/4th of the box
                paddingLeft: 2,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start', // Align the text to the left
                textAlign: 'left',
              }}
            >
              {/* Number (Bold) */}
              <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                1000
              </Typography>

              {/* Label (Smaller Text) */}
              <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                {item.label}
              </Typography>
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>

        {/* Open Request Section */}
        <Typography variant="h5" component="h5" sx={{ marginTop: 5, marginBottom: 2 }}>
          Open Requests
        </Typography>

        {/* Listing (Passing the current page to the Listing component) */}
        <Listing page={page} workOrders={WorkOrders} />

        {/* Pagination */}
        <Stack spacing={2} alignItems="center" justifyContent="center" sx={{ marginTop: 3 }}>
          <Pagination 
            count={Math.ceil(WorkOrders.length / 10)} 
            page={page} 
            onChange={handlePageChange} 
            color="primary" 
          />
        </Stack>
      </Box>

      {/* Filter Modal */}
      <Filter open={openFilter} handleClose={handleCloseFilter} />
    </DashboardLayoutSlots>
  );
};

export default Dashboard;
